import { SB } from '@play-co/replicant';

export default {
  // Game bumbum persistent data
  bumbum: SB.object({
    // Board
    board: SB.object({
      isFever: SB.boolean().default(false), // Fever mode
      fever: SB.number().min(0).default(0), // Fever score
      combo: SB.number().min(0).default(0), // Combo counter
      types: SB.array(SB.string()), // Pet type IDs list selected for ths game
      normal: SB.map(SB.number().min(0)), // normal pets count
      medium: SB.map(SB.number().min(0)), // medium pets count
      large: SB.map(SB.number().min(0)), // large pets count
      bombs: SB.map(SB.number().min(0)), // bomb pets count by type
    }).optional(),

    // Reward data
    rewards: SB.object({
      coins: SB.number().min(0),
      gems: SB.number().min(0),
      score: SB.number().min(0),
    }).optional(),

    // Score data map by weeks
    scores: SB.map(
      SB.object({
        score: SB.number().min(0),
        startedAt: SB.int().min(0),
        updatedAt: SB.int().min(0),
        claimed: SB.boolean().default(false),
      }),
    ),
  }).optional(),
};
